export class AutoridadesXTipoDTO {
    public organismId!: number;
    public organismName!: string;
    public correo!: string;
    public selected = false;
    public password!: string;
    public usuario!: string;

}

export interface interfaceAutoridadesXTipo{

  

     organismId: number,
     organismName: string,
     correo: string,
     selected: boolean,
     password: string,
     usuario: string;

}

export class RegistrarUsuarioCommand {
    public tipoOrganismoid!: number;
    public siglas!: string;
    public CatOrganismos: itemOrganos[] = [];

}

export class itemOrganos {
    public CatOrganismoId!: number;
    public CatOrganismoName!: string;
    public correo!: string;
}

export class ResponseRegistroUsuario {
    public catOrganismoId!: number;
    public nombreOrgano!: string;
    public password!: string;
    public usuario!: string;
}

export class PaginOrganos {
    public itypeOrg!: number;
    public iOrg!: number;
    public page!: number;
     public records!: number;
}